const drawerStyles = (tokens) => ({
    baseStyle: {
        dialog: {
            marginTop: '60px',
            button: {
                top: 4,
            },
            header: {
                fontSize: tokens.FontSize4,
                fontWeight: tokens.TextHeadingMedium1FontWeight,
                color: tokens.TextLight500,
                pb: tokens.Spacing04,
                borderBottomWidth: tokens.BorderWidth01,
                borderBottomColor: tokens.BorderLight500,
            },
        },
    },
    variants: {
        'clickable-overlay': {
            dialog: {
                pointerEvents: 'auto',
            },
            dialogContainer: {
                pointerEvents: 'none',
            },
        },
    },
});
export default drawerStyles;
